import { CustomDataKeys } from 'common/constants/custom-data-keys';

export const getCustomDataKey = (reportType: string) => {
  switch (reportType) {
    case 'source':
      return CustomDataKeys.MARKETING_SOURCE;
    case 'keywords':
      return CustomDataKeys.KEYWORD;
    case 'landing-page':
      return CustomDataKeys.LANDING_PAGE;
    case 'referrer':
      return CustomDataKeys.REFERRER;
    case 'utm-campaign':
      return CustomDataKeys.UTM_CAMPAIGN;
    case 'utm-medium':
      return CustomDataKeys.UTM_MEDIUM;
    case 'utm-content':
      return CustomDataKeys.UTM_CONTENT;
    case 'browser':
      return CustomDataKeys.BROWSER;
    case 'os':
      return CustomDataKeys.OPERATOR_SYSTEM;
    case 'device':
      return CustomDataKeys.DEVICE;
    default:
      throw Error(
        `Could not find custom data key for report type ${reportType}`
      );
  }
};
